// Filtros de pesquisa na URL (épico PO1-2280: Pesquisa CT-e e Pesquisa
// Importação). Funções puras, sem React, no padrão de Dashboard/abaDaUrl.js:
// a URL guarda só o que difere do padrão, preserva parâmetros alheios e ignora
// valores inválidos (enum fora da lista, inteiro não numérico).
//
// `definicao` = { chave: { padrao, tipo: "texto" | "inteiro" | "enum", opcoes } }.
// O valor padrão nunca vai para a URL; ao ler, o que falta ou é inválido volta
// ao padrão. Página e ordenação entram na mesma definição.

function normalizar(def, bruto) {
  if (bruto === null || bruto === undefined) return def.padrao;
  const texto = String(bruto).trim();
  if (texto === "") return def.padrao;
  if (def.tipo === "inteiro") {
    const n = Number(texto);
    if (!Number.isInteger(n)) return def.padrao;
    if (def.min !== undefined && n < def.min) return def.padrao;
    if (def.max !== undefined && n > def.max) return def.padrao;
    return n;
  }
  if (def.tipo === "enum") {
    // Casa sem distinguir caixa e devolve a grafia canônica da opção.
    const alvo = texto.toLowerCase();
    const opcao = (def.opcoes || []).find((o) => String(o).toLowerCase() === alvo);
    return opcao === undefined ? def.padrao : opcao;
  }
  return texto;
}

export function filtrosDaUrl(search, definicao) {
  const q = new URLSearchParams(search || "");
  const saida = {};
  Object.keys(definicao).forEach((chave) => {
    saida[chave] = normalizar(definicao[chave], q.get(chave));
  });
  return saida;
}

function ehPadrao(def, valor) {
  if (valor === null || valor === undefined || valor === "") return true;
  return String(valor) === String(def.padrao === null || def.padrao === undefined ? "" : def.padrao);
}

// Devolve o `search` com os filtros gravados; o que está no padrão sai da URL
// e os parâmetros que não pertencem à definição ficam como estavam.
export function urlComFiltros(search, filtros, definicao) {
  const q = new URLSearchParams(search || "");
  Object.keys(definicao).forEach((chave) => {
    const def = definicao[chave];
    const valor = normalizar(def, filtros ? filtros[chave] : undefined);
    if (ehPadrao(def, valor)) q.delete(chave);
    else q.set(chave, String(valor));
  });
  const s = q.toString();
  return s ? `?${s}` : "";
}

// Os filtros da tela (só os que não são padrão), prontos para a query da API e
// para o botão de exportação.
export function filtrosAtivos(filtros, definicao) {
  const saida = {};
  Object.keys(definicao).forEach((chave) => {
    const def = definicao[chave];
    const valor = normalizar(def, filtros ? filtros[chave] : undefined);
    if (!ehPadrao(def, valor)) saida[chave] = valor;
  });
  return saida;
}

export default filtrosDaUrl;
